import { render } from "./InstallScreen.vue?vue&type=template&id=5b55df12&scoped=true"
import script from "./InstallScreen.vue?vue&type=script&lang=js"
export * from "./InstallScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=5b55df12&lang=scss&scoped=true"
import "./InstallScreen.vue?vue&type=style&index=1&id=5b55df12&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b55df12"]])

export default __exports__